import {DoctorScheduleModel} from '../../../../../models/doctors/doctor-schedule.model';
import {EnumValidValueItemModel} from '../../../../../models/enum/enum-valid-value-item.model';

export class TdoOrganizerFilterResultModel {
  doctor: DoctorScheduleModel;
  referringDoctor: DoctorScheduleModel;

  isInTreatment = false;
  isCompletedCases = false;
  isNoDefinitiveEndoPerformed = false;
  isSuperRecall = false;
  isGentleWaveProcedure = false;

  categoriesEnums: string[] = [];
  isAllCategoriesMustBePresent = false;

  range: EnumValidValueItemModel;
  // Default start to 10 years earlier and end to current date.  This will prevent a ton of if statements on the backend.
  todayDate = new Date();

  // startDate = new Date(2016, 0, 1);
  startDateMs = new Date(2016, 0, 1).getTime();

  // endDate = this.todayDate;
  endDateMs = this.todayDate.getTime();

  _startDate: Date;
  _endDate: Date;

  isWasNotApplied = false;

  constructor() {
    this.startDate = new Date(this.startDateMs);
    this.endDate = new Date(this.endDateMs);
  }

  set startDate(date: Date) {
    this._startDate = date;
    this.startDateMs = date.getTime();
  }

  get startDate() {
    return this._startDate;
  }

  set endDate(date: Date) {
    this._endDate = date;
    this.endDateMs = date.getTime();
  }

  get endDate() {
    return this._endDate;
  }

}
